import { createDetailRenderer } from '@leverege/api-ui-fota-management/lib/attributes/renderers/FotaLoaderRenderer';
export default ({
  blueprint,
  deviceType
}) => ({
  attrName: `${deviceType?.id}.percentDevicesAtFirmwareApplication`,
  objectType: blueprint.type,
  renderer: createDetailRenderer(`${deviceType?.id}.percentDevicesAtFirmwareApplication`, blueprint.type),
  handles: () => true
});